<div class="mobile">
  <ng-content select="[mobile]" />
</div>

<div class="desktop">
  <ng-content select="[desktop]" />
</div>

<div class="general">
  <ng-content />
</div>
